<template>
    <div>
        <div class="mb-5 border-b-1 pb-10">
            <div class="grid grid-cols-12 justify-between gap-6">
                <div class="col-span-12 md:col-span-6">
                    <h2 class="pt-0 lg:w-[450px]">
                        <nuxt-link
                            to="/clanky/uvod"
                            class="underline"
                        >
                            Encyklopedie názvů pražských veřejných prostranství
                        </nuxt-link>
                    </h2>

                    <p class="mt-5 mb-5 font-bold">
                        Ztrácíte se v pražských ulicích? Nejste sami.
                    </p>

                    <p class="mt-5 mb-5">
                        Jak vznikl Pražský uličník, jedinečná encyklopedie názvů
                        ulic, a proč bylo vhodné vytvořit jeho digitální verzi?
                        Přečtěte si příběh projektu, který pomáhá zorientovat se
                        v historii i současnosti pražských veřejných
                        prostranství.
                    </p>

                    <p class="mt-5 font-bold">
                        >
                        <nuxt-link
                            to="/clanky/uvod"
                            class="underline"
                        >
                            více
                        </nuxt-link>
                    </p>
                </div>

                <div class="col-span-12 md:col-span-6">
                    <img
                        src="../public/img/titulni_obrazek.jpg"
                        alt=""
                        class="h-[272px] w-full object-cover"
                    />
                </div>
            </div>
        </div>

        <!-- Vyhledávání ulic -->
        <SearchInputSuggestions />

        <AppFooter />
    </div>
</template>
<script setup lang="ts"></script>

<style scoped></style>
